var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.images.length)?_c('v-container',{staticClass:"slider px-0 py-0",attrs:{"fluid":""}},[_c('Carousel',_vm._b({staticClass:"d-flex h100 w100",attrs:{"loop":""}},'Carousel',
			_vm.$b.props({
				autoplayDelay: _vm.autoplayDelay,
			})
		,false),_vm._l((_vm.data.images),function(i,index){return _c('SafeLink',{key:index,attrs:{"to":i.link}},[_c('Media',{attrs:{"cover":"","width":"100%","src":_vm.$b({ m: i.imgMobile || i.img, td: i.img }),"aspect-ratio":_vm.imagesRatio}})],1)}),1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }